import { render, staticRenderFns } from "./exportDownInfo.vue?vue&type=template&id=242f805c&scoped=true&"
import script from "./exportDownInfo.vue?vue&type=script&lang=js&"
export * from "./exportDownInfo.vue?vue&type=script&lang=js&"
import style0 from "./exportDownInfo.vue?vue&type=style&index=0&id=242f805c&lang=less&scoped=true&"
import style1 from "./exportDownInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242f805c",
  null
  
)

export default component.exports